module.exports = "pegasus/assets/theme4/small/2.jpg";